import { React, Component } from 'utils';
import { App, SelectedPavilionStore } from 'model';
import './whyus.less';
import PointOfInterest from '../pointofinterest';

export default class WhyUs extends Component {

	render() {
		var pavilion = SelectedPavilionStore.getSelectedPavilion();
		var { data, stand } = this.props;
		var { standElement:element } = data;

		var style = {
			width: element.width,
			height: element.height
		}

		var variation = App.filename(element.imageUrl);
		var css = ['box', variation];
		var url = App.activityUrl(pavilion, stand, 'why')

		return <div className={ css.join(' ') }>
			<PointOfInterest to={url} name={element.standFeature.name}/>
			<img src={ element.imageUrl } style={ style } />
		</div>
	}
}



// WEBPACK FOOTER //
// ./src/modules/components/elements/whyus.js